'use client';

import type { FC, JSX } from 'react';
import React from 'react';
import type { ApiProductsCacheResponse } from '@ibe/api';
import type { PartialPageProps } from '@/types/cms/magnolia';
import dynamic from 'next/dynamic';
const ProductPageViewEventWrapper = dynamic(
  () => import('@/templates/ProductPageViewEventWrapper')
);

const ProductPageViewEventWrapperImportLoader: FC<{
  pageProps?: PartialPageProps;
  selectedProductPackage?: Partial<ApiProductsCacheResponse>;
}> = ({ pageProps, selectedProductPackage }): JSX.Element => {
  return (
    <ProductPageViewEventWrapper
      pageProps={pageProps}
      selectedProductPackage={selectedProductPackage}
    />
  );
};

export default ProductPageViewEventWrapperImportLoader;
